import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Sections/S1_Header";
import About from "../../Sections/S2_About";
import Features from "../../Sections/S3_Features";
import Numbers from "../../Sections/S4_Numbers";
import RoadMap from "../../Sections/S5_Raodmap";
import Announcements from "../../Sections/S6_Announcements";
import Team from "../../Sections/S7_Team";
import Invest from "../../Sections/S8_Invest";
import Partners from "../../Sections/S9_Partners";

const Home = () => {
    return(
        <div className="App">
            <Header />
            <About />
            <Features />
            <Numbers />
            <RoadMap />
            <Announcements />
            <Team />
            <Partners />
            <Invest />
            <Footer />
            
            <a href="https://t.me/MetaSnooker"
                target="blank"
                className="MS---Neon--Button btn d-sm-none d-block text-center"
                data-aos="zoom-in"
                style={{position: 'fixed', bottom: 0, width: '-webkit-fill-available', zIndex: 37}}
            >
                Join us
            </a>
        </div>
    );
}

export default Home;